import React from 'react';
import { buscarFormulario, getInformacoesDoForm, confirmacaoPorEmail, alterarDataLimiteConfirmacaoEmail, enviarComunicadoPorEmail } from '../../actions/FormActions';
import {View, FieldsGroup, FieldDetail, ActionButton, Card, LinkAction, ButtonFields, CalendarField, Message, InputField} from 'react-template';
import {setHoursInDay, formatLongToDate} from '../../../../helpers/Data'
export default class FormHome extends View {

    EMAIL_STATUS = {
        ENVIANDO_EMAILS: "ENVIANDO_EMAILS",
        EMAILS_ENVIADOS_SUCESSO: "EMAILS_ENVIADOS_SUCESSO",
        EMAILS_ENVIADOS_ERRO: "EMAILS_ENVIADOS_ERRO",
    }


    constructor(props){
        super(props);
        this.state = {  formulario: {}, 
                        schema: {},
                        status: '',
                        formInfo: {},
                        activeLoader: true,
                        dataMaxima: null,
                        comunicado: "",
                     }
        this.setDataMaxima = this.setDataMaxima.bind(this)
    }

    componentWillMount(){
        this.loadForm(this.props.params.id)
    }

    loadForm(formID){
        buscarFormulario(formID, res => {
            const formulario = res.data
            const schema = JSON.parse(formulario.formSchema).schema

            // Define o modelo que texto do status na tela
            const statusTitulo = formulario.status ?  'Diponível para o público' : 'Indiponível para o público'
            const statusCor = formulario.status ? ' green' : ' red'
            const status = formulario.status

            this.setState({...this.state, formulario: formulario, schema: schema, status: status, statusTitulo: statusTitulo, statusCor: statusCor})

        }, 
        error => {
            this.notifyError('Erro ao carregar Formulário!', '');
        })

        getInformacoesDoForm(formID, res => {
            let formInfo = res.data

            if(formInfo.qtdeVagasRestantes < 0){
                formInfo.qtdeVagasRestantes = 'Vagas Ilimitadas'
            } else {
                formInfo.qtdeVagasRestantes = `${formInfo.qtdeVagasRestantes} Vagas Restantes`
            }
            
            if(formInfo.qtdeCertificadosGerados >= 0 ){
                formInfo.qtdeCertificadosParaSeramGerados = formInfo.qtdeSubmissoes - formInfo.qtdeCertificadosGerados
            }

            if(formInfo.qtdePresentes >= 0 ){
                formInfo.qtDeFaltantes = formInfo.qtdeSubmissoes - formInfo.qtdePresentes
            }

            this.setState({...this.state, formInfo, activeLoader: false})
        }, 
        error => {
            this.setState({activeLoader: false});
            this.notifyError('Erro ao carregar Informações do Formulário', '');
        })
    }

    getStatus(){
        return <LinkAction icone={this.state.status ? 'done' : 'clear'} type="icon" tooltip={this.state.statusTitulo} color={this.state.statusCor}/>  
    }

    switchDateClass = (id, remove, add) => {
        let c = document.getElementById(id).firstChild
        c.classList.remove(remove)
        c.classList.add(add)
    }

    setDataMaxima(e, data){
        this.switchDateClass('data-maxima', 'invalid', 'valid')
        this.setState({dataMaxima: data.value})
    }

    getCalendar = (update = false) => {
        return (
            <div className="p-t">
                <section>Informe, a baixo, uma data limite para que o inscrito possa confirma sua inscrição e torna-la válida.</section>
                {update && (
                    <section><b>Data Atual: </b> {formatLongToDate(this.state.formulario.dataLimiteConfirmacaoEmail)} </section>
                )}
                <section id="data-maxima">
                    <CalendarField
                        className="m-l-0"
                        id={`valor-predefinido`}    
                        name="calendar-datamaxima"
                        key={'datamaxima'}
                        value={this.state.dataMaxima}
                        onChange={this.setDataMaxima}
                        width={6} phoneWidth={4} tabletWidth={8}
                        invalidMessage="Campo Obrigatório"
                        label='Data máxima para Confirmação' 
                        required
                        calendarConfig={{type: 'date', minDate: new Date()}} 
                        />
                </section>
            </div>
        )
    }

    sendMailConfirmation = () => {
        
        if(this.state.dataMaxima){
            confirmacaoPorEmail(this.props.params.id, setHoursInDay(new Date(this.state.dataMaxima).getTime()), res => {
                this.notifySucess('Sucesso', res.data);
                let form = this.state.formulario
                form.estadoEnvioEmail = this.EMAIL_STATUS.ENVIANDO_EMAILS
                form.dataLimiteConfirmacaoEmail = new Date(this.state.dataMaxima).getTime()
                this.setState({formulario: form})
            }, error => {
                this.notifyError('Erro', error);
            })
        } else {
            this.switchDateClass('data-maxima','untouched', 'touched')
            throw "Data máxima inválida"
        }

    }

    getMaxDateToConfirmeMail = () => {
        this.displayModal('Data máxima para realizar a confirmação', '', this.getCalendar(), this.sendMailConfirmation, () => {this.setState({dataMaxima: null})})
    }

    changeDateToConfirme = () => {
        if(this.state.dataMaxima){
            alterarDataLimiteConfirmacaoEmail(this.props.params.id, setHoursInDay(new Date(this.state.dataMaxima).getTime()), res => {
                this.notifySucess('Sucesso', "Data atualizada com sucesso");
                let form = this.state.formulario
                form.dataLimiteConfirmacaoEmail = res.data.dataLimiteConfirmacaoEmail
                this.setState({formulario: form})
            }, error => {
                this.notifyError('Erro', error);
            })
        } else {
            this.switchDateClass('data-maxima', 'untouched', 'touched')
            throw "Data máxima inválida"
        }
    }

    getChangeMaxDateToConfirmeMail = () => {
        this.displayModal('Alterar data máxima para realizar a confirmação', '', this.getCalendar(true), this.changeDateToConfirme, () => {this.setState({dataMaxima: null})})
    }



    sendMailCommunicated = () => {
        if(this.state.comunicado.length > 0) {
            enviarComunicadoPorEmail(this.props.params.id, this.state.comunicado, res => {
                this.notifySucess('OK', "Data atualizada com sucesso");
            }, error => {
                this.notifyError('Erro', error);
            })
        } else {
            this.switchDateClass('messagem-comunicado', 'untouched', 'touched')
            throw "Messagem de comunicado não informada"
        }
    }

    setMessageCommunicated = (e, data) => {
        this.switchDateClass('messagem-comunicado', 'invalid', 'valid')
        this.setState({comunicado: data.value})
    }

    getMessageDetail = () => {
        return (
            <div className="p-t">
                <section>Digite, no campo abaixo, uma mensagem para ser enviada, por email, a todos os inscritos no formulário.</section>
                <section id="messagem-comunicado">
                    <InputField 
                        className="m-l-0 m-r-0"
                        onChange={this.setMessageCommunicated} 
                        label="Mensagem a ser enviada" 
                        textarea
                        placeholder='' 
                        rows="6"
                        invalidMessage={"Campo Obrigatório"}
                        required />
                </section>
            </div>
        )
    }

    sendCommunicatedToMail = () => {
        this.displayModal('Comunicado por Email', '', this.getMessageDetail(), this.sendMailCommunicated, () => {this.setState({comunicado: ""})})
    }

    getSolicitarConfirmacaoButton = () => {
        if(this.state.formulario && this.state.formulario.confirmarPorEmail){
            if(this.state.formulario.estadoEnvioEmail !== this.EMAIL_STATUS.EMAILS_ENVIADOS_SUCESSO){
                return <ButtonFields content="Solicitar Confirmação por email" icon="mail_outline" color="primary" button="colored" disabled={(this.state.formulario.estadoEnvioEmail !== null && this.state.formulario.estadoEnvioEmail !== this.EMAIL_STATUS.EMAILS_ENVIADOS_ERRO) || this.state.formInfo.qtdeSubmissoes === 0} onClick={this.getMaxDateToConfirmeMail} /> 
            } else {
                return <ButtonFields content="Alterar Data Limite" icon="calendar_today"  button="colored" color="red" onClick={this.getChangeMaxDateToConfirmeMail} /> 
            }
        } 
    }

    getActions = () =>{
        return (
            <div>
                {this.getSolicitarConfirmacaoButton()}
                <ButtonFields className="m-l" content="Enviar Comunicado" icon="mail_outline" color="green" button="colored"  onClick={this.sendCommunicatedToMail} /> 
            </div>
        )
    }

    getMailStatusMessage = () => {
        if(this.state.formulario !== null)
            if(this.state.formulario.estadoEnvioEmail === this.EMAIL_STATUS.ENVIANDO_EMAILS){
                return (
                    <Message type={'warning'}
                        title={'Emails sendo enviados'}
                        message={"Aguarde enquanto todos os email estão sendo enviados pelo sistema."}/>
                )
            } else if(this.state.formulario.estadoEnvioEmail === this.EMAIL_STATUS.EMAILS_ENVIADOS_SUCESSO){
                return (
                    <Message type={'success'}
                        title={'Emails enviados com sucesso'}
                        message={"Os email foram enviados para os inscritos com sucesso. Data limite para confirmação: " + formatLongToDate(this.state.formulario.dataLimiteConfirmacaoEmail)}/>
                )
            } else if(this.state.formulario.estadoEnvioEmail === this.EMAIL_STATUS.EMAILS_ENVIADOS_ERRO){
                return (
                    <Message type={'error'}
                        title={'Erro ao enviar emails'}
                        message={"Um erro ocorreu ao tentar enviar os email. Tente novamento mais tarde."}/>
                )
            }
    }

    render() {
        
        return (
            <div>
                <Card titulo={this.state.schema.title} descricao={this.state.schema.description} actions={this.getActions()} tools={this.getStatus()} displayLoading={this.state.activeLoader} loadingPosition='top'>
                    <FieldsGroup>
                        <FieldDetail width={3} titulo="Inscritos" content={`${this.state.formInfo.qtdeSubmissoes} `}/>
                        <FieldDetail width={3} titulo="Vagas" content={`${this.state.formInfo.qtdeVagasRestantes} `}/>
                    </FieldsGroup>

                    {this.state.formInfo.qtdeBoletosPagos >= 0 && ([
                        <FieldsGroup>
                            <FieldDetail width={3} titulo="Pagos" content={`${this.state.formInfo.qtdeBoletosPagos} `}/>
                            <FieldDetail width={3} titulo="Total Recebido" content={`R$ ${this.state.formInfo.valorDosBoletos}`}/>
                        </FieldsGroup>
                    ])}

                    {this.state.formInfo.qtdePresentes >= 0 && ([
                        <FieldsGroup>
                            <FieldDetail width={3} titulo="Presentes" content={`${this.state.formInfo.qtdePresentes} `}/>
                            <FieldDetail width={3} titulo="Faltaram" content={`${this.state.formInfo.qtDeFaltantes} `}/>
                        </FieldsGroup>
                    ])}
                    <ActionButton label="Editar" icon="edit" to={`/admin/formulario/${this.props.params.id}/editar`}/>
                </Card>

                {this.getMailStatusMessage()}

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/view/formulario/list/tabs/FormHome.js